import PropTypes from 'prop-types';
import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';
import { TabPanel, TabView } from 'primereact/tabview';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useGetCouncilMailLogs } from 'utils/hooks/councils';
import { COUNCIL_EMAIL_TYPES } from 'constant';
import { formatDatetime } from 'utils/func';

export default function ViewMailLogs({ visible, setVisible, params }) {
  const { t } = useTranslation();

  const { data: remindMailLogs } = useGetCouncilMailLogs(
    params?.id,
    { emailType: COUNCIL_EMAIL_TYPES.REMIND, memberId: params?.memberId },
    { enabled: visible }
  );
  const { data: establishCouncilMailLogs, isLoading: isLoadingEstablishCouncilMailLogs } =
    useGetCouncilMailLogs(
      params?.id,
      { emailType: COUNCIL_EMAIL_TYPES.ESTABLISH_COUNCIL, memberId: params?.memberId },
      { enabled: visible }
    );

  const formatHeader = () => (
    <div>
      <p className="text-blue-500">{t('council.mailLog.title')}</p>
    </div>
  );

  const formatSentAt = (value) => <div>{formatDatetime(value?.sent_at, 'DD/MM/YYYY HH:mm')}</div>;

  const formatStatus = (value) => (
    <div>
      {value?.status === 1 ? t('council.mailLog.status.success') : t('council.mailLog.status.fail')}
    </div>
  );

  const formatBody = (value) => (
    // eslint-disable-next-line react/no-danger
    <div style={{ whiteSpace: 'pre-wrap' }} dangerouslySetInnerHTML={{ __html: value?.body }} />
  );

  return (
    <Dialog
      header={formatHeader()}
      visible={visible}
      position="center"
      style={{ width: '60vw' }}
      onHide={() => setVisible(false)}
      draggable={false}
    >
      <TabView>
        <TabPanel header={t('council.mailLog.header.establishCouncil')}>
          <DataTable
            value={establishCouncilMailLogs.data}
            className="p-datatable-gridlines header-table"
            dataKey="id"
            showGridlines
            loading={isLoadingEstablishCouncilMailLogs}
            emptyMessage={t('council.mailLog.empty')}
          >
            <Column
              header={t('council.mailLog.fields.subject')}
              field="subject"
              className="w-14rem"
              style={{ minWidth: '10rem' }}
            />
            <Column
              header={t('council.mailLog.fields.sentDate')}
              field="sent_at"
              className="w-4rem text-center"
              body={formatSentAt}
              frozen
              alignFrozen="right"
            />
            <Column
              header={t('council.mailLog.fields.status')}
              field="status"
              className="w-4rem text-center"
              body={formatStatus}
              frozen
              alignFrozen="right"
            />
          </DataTable>
        </TabPanel>
        <TabPanel header={t('council.mailLog.header.remind')}>
          <DataTable
            value={remindMailLogs.data}
            className="p-datatable-gridlines header-table"
            dataKey="id"
            showGridlines
            loading={isLoadingEstablishCouncilMailLogs}
            emptyMessage={t('council.mailLog.empty')}
          >
            <Column
              header={t('council.mailLog.fields.subject')}
              field="subject"
              className="w-10rem"
              style={{ minWidth: '10rem' }}
            />
            <Column
              header={t('council.mailLog.fields.body')}
              field="body"
              className="w-18rem"
              body={formatBody}
              frozen
              alignFrozen="right"
            />
            <Column
              header={t('council.mailLog.fields.sentDate')}
              field="sent_at"
              className="w-4rem text-center"
              body={formatSentAt}
              frozen
              alignFrozen="right"
            />
            <Column
              header={t('council.mailLog.fields.status')}
              field="status"
              className="w-4rem text-center"
              body={formatStatus}
              frozen
              alignFrozen="right"
            />
          </DataTable>
        </TabPanel>
      </TabView>
    </Dialog>
  );
}

ViewMailLogs.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  params: PropTypes.object.isRequired,
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
};
